import React from "react";

import Modal from "../Elements/Modal/Modal";
import MainButton from "../Elements/MainButton/MainButton";
import SecondButton from "../Elements/SecondButton/SecondButton";

import "./ProfileModals.css";

const WalletIdModal = ({ isOpen, onClose, id }) => {
  const handleCopy = () => {
    if (!id) return;
    navigator.clipboard?.writeText(id).catch(() => {});
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Wallet ID"
      actions={
        <>
          <SecondButton onClick={onClose}>Close</SecondButton>
          <MainButton onClick={handleCopy}>Copy ID</MainButton>
        </>
      }
    >
      <div className="profile-wallet-id-body">
        <p className="profile-wallet-id-label">Your wallet identifier:</p>
        <code className="profile-wallet-id-code">{id}</code>
        <p className="profile-wallet-id-hint">
          This wallet ID can be used to receive balance transfers between users. Share it only with people you trust.
        </p>
      </div>
    </Modal>
  );
};

export default WalletIdModal;
